module.exports = __webpack_public_path__ + "static/media/pc.a1ef11b5.jpeg";